/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Origin_Compliance_LlmInputs */



/**
* | output |
* | --- |
* | "Compliance LLM" |
*
* @param {Audit_Origin_Compliance_LlmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_origin_compliance_llm = /** @type {((inputs?: Audit_Origin_Compliance_LlmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Origin_Compliance_LlmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance LLM")
	return /** @type {LocalizedString} */ ("Compliance LLM")
});